import './Progetto.css';
import ProgettoNav from './ProgettoNav';

function Progetto2() {
    return (
        <div className='progetto-container'>
            <ProgettoNav prevPath='/progetto-voce-volontari' nextPath='/progetto-locali-storici' />
            <h1 className='progetto-title'>RELAZIONE PROGETTO "DONNA: QUANDO IL TUO CORPO TI TRADISCE"</h1>

            <h3>AMBITO PRIORITARIO</h3>
            <p>
                L'Associazione Settemotivi e Radio Cosmo di Pordenone ha istruito un progetto nella finalità
                di sensibilizzare la popolazione sia per la prevenzione sia per la diagnostica precoce delle
                neoplasie del seno, essendo questa una patologia che colpisce le donne (e non solo) in tutte
                le fasce di età.
            </p>
            <p>
                Il progetto è stato articolato in interviste a otto esperti del C.R.O. di Aviano e
                dell'Ospedale S. Maria degli Angeli di Pordenone, nonché a tre pazienti (due donne e un uomo)
                per raccogliere le loro testimonianze.
            </p>

            <h3>INTERVISTE AGLI ESPERTI</h3>
            <p>1 – Dott.ssa Maria Antonietta Annunziata, Psicologa, Servizio di Psicologia del C.R.O. di Aviano: ha relazionato su:</p>
            <ul className='progetto-indent'>
                <li>impatto psicologico del tumore a seni nelle giovani donne, la reazione alla comunicazione e le possibili paure sul proprio futuro di madre e di moglie</li>
                <li>come comunicare la diagnosi in famiglia</li>
                <li>le modalità di affrontare percorso terapeutico</li>
                <li>il supporto della cosiddetta "riabilitazione" psicologica</li>
                <li>reazioni ai tipi di intervento chirurgico, la protesi come ricostruzione della femminilità</li>
                <li>quali i rapporti con il partner</li>
                <li>preoccupazioni per la possibile ereditarietà familiare</li>
                <li>rapporti con il lavoro per le assenze</li>
            </ul>
            <p>2 – Dott. Michele Bartoletti, Dipartimento di Oncologia Clinica del C.R.O. di Aviano, ha relazionato su:</p>
            <p>a – tumore dell'ovaio</p>
            <ul className='progetto-indent'>
                <li>epidemiologia del tumore dell'ovaio, che talora avviene nelle portatrici delle stesse mutazioni genetiche del tumore del seno</li>
                <li>sintomatologia, diffusione locale e a distanza</li>
                <li>diagnostica clinica, strumentale e teste genetici</li>
                <li>estensione dei test genetici ai familiari sani</li>
                <li>terapia chirurgica, medica e radioterapica</li>
                <li>possibili nuove frontiere farmacologiche</li>
            </ul>
            <p>b – tumore dell'endometrio</p>
            <ul className='progetto-indent'>
                <li>epidemiologia, cause, familiarità</li>
                <li>sintomatologia</li>
                <li>diagnosi precoce</li>
                <li>terapia chirurgica, medica e radioterapica</li>
                <li>come intercettare le donne con tumore ereditario</li>
            </ul>
            <p>3 – Dott.ssa Silvia Franceschi, Direzione scientifica del C.R.O. di Aviano, ha relazionato su:</p>
            <ul className='progetto-indent'>
                <li>epidemiologia dell'infezione da papillomavirus nelle donne e nei maschi</li>
                <li>come si trasmette l'infezione</li>
                <li>decorso dell'infezione</li>
                <li>evoluzione delle lesioni da HPV</li>
                <li>importanza del test per l'HPV</li>
                <li>vaccinazione anti-HPV: età, dosi</li>
            </ul>
            <p>4 – Dott. Mattia Garutti, Oncologo di Oncologia Medica e Prevenzione Oncologica del C.R.O. di Aviano, ha relazionato su:</p>
            <ul className='progetto-indent'>
                <li>ambulatorio di prevenzione: di cosa si occupa, come si accede e come funziona</li>
                <li>per la prevenzione del tumore la seno la donna deve imparare a conoscere il proprio corpo</li>
                <li>consulto e valutazione del senologo, mammografia di screening. Ecografia mammaria</li>
                <li>fattori predisponenti al tumore del seno non modificabili: sesso, età e mutazioni genetiche</li>
                <li>test genetici e genomici</li>
                <li>fattori predisponenti al tumore dei seni modificabili: stili di vita: fumo, alimentazione, consumo di bevande alcoliche, obesità, attività fisica, gravidanze, allattamento al seno, uso di anticoncezionali.</li>
            </ul>
            <p>5 – Dott.ssa Elvia Micheli, Chirurga già Responsabile Chirurgia Senologica dell'Ospedale Santa Maria degli Angeli di Pordenone, ha relazionato su:</p>
            <p>a – prima intervista: dal sospetto alla diagnosi:</p>
            <ul className='progetto-indent'>
                <li>cause del tumore al seno</li>
                <li>prevenzione: autopalpazione, mammografia</li>
                <li>quando e perché fare il test genetico</li>
                <li>approfondimenti diagnostici: ecografia, FNAC e FNAB, RNM</li>
                <li>Unità di Senologia: importanza della decisione collegiale</li>
            </ul>
            <p>a – seconda intervista: dalla diagnosi alla terapia:</p>
            <ul className='progetto-indent'>
                <li>terapia conservativa (tumorectomia, quadrantectomia)</li>
                <li>radioterapia intraoperatoria e postoperatoria</li>
                <li>terapia demolitiva: mastectomia con o senza ricostruzione</li>
                <li>intervento sui linfonodi</li>
                <li>ricostruzione con lipostruttura, con lombo</li>
                <li>ricostruzione del complesso areola capezzolo</li>
                <li>complicanze immediate e a distanza e loro prevenzione</li>
            </ul>
            <p>6 – Prof. Fabio Puglisi, Direttore del Dipartimento di Oncologia Medica del C.R.O. di Aviano ha relazionato su:</p>
            <ul className='progetto-indent'>
                <li>cosa è la caratterizzazione biomolecolare</li>
                <li>medicina di precisione</li>
                <li>ruolo dello scambio fra ricerca e clinica</li>
                <li>la biopsia liquida</li>
                <li>la portatrice del cosiddetto triplo negativo</li>
                <li>percorso e fasi della malattia tumorale</li>
                <li>possibile futuro della donna con tumore del seno primitivo e avanzato</li>
                <li>chemioterapia strettamente personalizzata</li>
                <li>terapia neoadiuvante</li>
                <li>l'impatto della chemioterapia sulla fertilità</li>
                <li>l'influenza dei social per la prevenzione della malattia</li>
                <li>raccomandazioni alla paziente con figli sia femmine sia maschi</li>
                <li>prospettive future della terapia oncologica</li>
            </ul>
            <p>7 – Dott.ssa Nadia Sinicco, Psichiatra, Psicoterapeuta, già dipendente dell'Azienda Sanitaria di Pordenone, libero professionista, ha relazionato su:</p>
            <ul className='progetto-indent'>
                <li>l'impatto psicologico alla diagnosi: ansia, depressione, sconforto</li>
                <li>paura della malattia, possibilità di guarigione? Morte?</li>
                <li>supporto dello Psicoterapeuta lungo il percorso chemioterapico della malattia, della tipologia dell'intervento chirurgico, della radioterapia</li>
                <li>come cambia il rapporto con il proprio corpo dopo la diagnosi di tumore al seno e dopo l'intervento chirurgico</li>
                <li>la donna con tumore al seno e la famiglia (marito/compagno, figli, genitori, fratelli)</li>
                <li>preoccupazione per l'attività lavorativa</li>
            </ul>
            <p>8 – Dott. Lorenzo Vinante, Radioterapista, Referente Unità Senologica per la Radioterapia del C.R.O. di Aviano ha relazionato su:</p>
            <ul className='progetto-indent'>
                <li>scopo dell'impiego della radioterapia</li>
                <li>indicazioni della radioterapia</li>
                <li>modalità più diffuse dell'impiego della radioterapia</li>
                <li>radioterapia intraoperatoria</li>
                <li>pianificazione del trattamento dal centraggio alle sedute di radioterapia</li>
                <li>raccomandazioni prima, durante e dopo l'esecuzione della radioterapia</li>
                <li>effetti collaterali a breve e lunga distanza</li>
                <li>radioterapia con controllo del respiro</li>
                <li>il trattamento con protoni</li>
            </ul>

            <h3>INTERVISTE A PAZIENTI</h3>
            <p>Alle due pazienti sono state poste le stesse domande per rilevare come ognuna ha vissuto la propria malattia</p>
            <p>1 – S. Z. di anni 50, insegnante</p>
            <p>2 – M. S. di anni 57, impiegata</p>
            <ul className='progetto-indent'>
                <li>gravidanze, allattamento al seno, uso di anticoncezionali, stili di vita (in particolare consumo di bevande alcoliche, fumo, alimentazione, attività fisica</li>
                <li>precedenti oncologici, in particolare mammari, in familiari</li>
                <li>come e quando consapevolezza di possibile neoplasia del seno</li>
                <li>reazioni alla comunicazione della diagnosi e del tipo di terapia (medica, chirurgica, radioterapica)</li>
                <li>come ha vissuto il percorso terapeutico</li>
                <li>comunicazione e reazioni in famiglia: partner, figli, genitori, fratelli</li>
                <li>rapporti con il partner</li>
                <li>rapporto con il proprio corpo</li>
                <li>la ricostruzione mammaria per il ripristino della femminilità</li>
                <li>il ricorso al supporto psicologico e psicoterapeutico</li>
                <li>bisogno di salute e lavoro</li>
                <li>aspettative, speranze, paure, certezze</li>
            </ul>
            <p>Per il paziente maschio sono state previste altre domande, essendo la neoplasia mammaria rara nel genere maschile, solo alcune le stesse onde rimarcare le differenze di genere per la convivenza con una neoplasia della stessa struttura anatomica ma notevolmente diversa per volume e funzione</p>
            <p>3 – D. N di anni 48, operaio</p>
            <ul className='progetto-indent'>
                <li>possibili precedenti di neoplasia mammaria nei familiari</li>
                <li>parenti con mutazione genetiche BRCA2 e BRCA1</li>
                <li>stili di vita: fumi, bevande alcoliche, alimentazione, attività fisica</li>
                <li>come e quando rilievo di variazione del seno</li>
                <li>quanto tempo dopo una valutazione specialistica oncologica</li>
                <li>reazione personale e dei familiari alla comunicazione alla diagnosi</li>
                <li>gli accertamenti successivi tra cui i test genetici</li>
                <li>tipo di intervento</li>
                <li>comportamento durante il percorso terapeutico</li>
                <li>rapporto con il proprio corpo ed eventuale bisogno di supporto psicologico</li>
                <li>cambio degli stili di vita in particolare fumo, alcolici, alimentazione</li>
                <li>aspettative future, speranze, paura, certezze</li>
            </ul>

            <h3>INCONTRO APERTO AL PUBBLICO</h3>
            <p>
                In data 22.05.2023 dalle ore 18.00 alle 20.00 incontro aperto al pubblico presso la Sala del
                Ballatoio del Palazzo Ragazzoni di Sacile con il Patrocinio del Comune di Sacile e del Centro
                di Riferimento Oncologico di Aviano.
            </p>
            <p>Grande affluenza di pubblico</p>
            <p>Hanno partecipato e risposto alle varie domande dei presenti, dopo breve relazione i seguenti esperti:</p>
            <ul className='progetto-indent'>
                <li>Prof. Fabio Puglisi, "la terapia oncologica oggi"</li>
                <li>Dott. Michele Bartoletti, "attualità in tema di tumori ginecologici"</li>
                <li>Dott.ssa Silvia Franceschi, "la vaccinazione anti-HPV"</li>
                <li>Dott.ssa Angela Caroli C.R.O. in sostituzione del Dott. Lorenzo Vinante "la radioterapia a supporto"</li>
                <li>Dott.ssa Elvia Micheli, "la chirurgia nelle neoplasie del seno"</li>
                <li>Dott.ssa Maria Antonietta Annunziata, "il supporto psicologico"</li>
                <li>Dott.ssa Nadia Sinicco, "l'aiuto della psicoterapeuta"</li>
            </ul>

            <h3>Programmazione Radiofonica</h3>
            <p>
                Tutte le interviste ai professionisti e le testimonianze, sono state trasmesse nella radio
                digitale "Radio Cosmo", che ha mandato in diretta anche l'evento conclusivo del 22 maggio
                2023 presso la Sala del Ballatoio di Palazzo Ragazzoni di Sacile.
            </p>
            <p>
                Pur essendo il progetto chiuso alla data del 22 maggio 2023, il Direttore Responsabile
                dell'emittente, a richiesta di chi non ha potuto seguire in radio le puntate trasmesse,
                ha disposto la replica delle stesse.
            </p>
            <p>
                Le interviste agli esperti sono state registrare anche in video e saranno prossimamente
                rese disponibile nelle pagine social della Radio.
            </p>

            <h3>Durata del progetto</h3>
            <p>Il progetto è stato realizzato dal 1° settembre 2022 al 31 maggio 2023.</p>

            <h3>Estensione territoriale</h3>
            <p>
                Il progetto ha coinvolto direttamente i comuni di Pordenone, Sacile, Cordenons, Porcia,
                Aviano per quanto riguarda le interviste e le testimonianze, altri Comuni con la presenza
                di alcuni volontari nelle piazze, mentre la diffusione radiofonica ha permesso l'ascolto
                e la fruizione del progetto in tutta la Regione.
            </p>

            <h3>Partner</h3>
            <p>
                Nessun partner coinvolto nel progetto. Solo l'evento finale è stato condiviso con la
                SO.GI.T di Sacile e con il Patrocinio del Comune di Sacile.
            </p>

            <h3>Volontari coinvolti</h3>
            <p>
                I volontari coinvolti nel progetto nel periodo 1° settembre 2022 – 31 maggio 2023 sono
                in numero di 5, di cui tre per tutto il periodo ed altri per periodi diversi.
            </p>
            <ProgettoNav prevPath='/progetto-voce-volontari' nextPath='/progetto-locali-storici' />
        </div>
    );
}

export default Progetto2;
